import styled from '@emotion/styled';
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',

  div: {
    height: '50px',
    borderRadius: '100px',
    backgroundColor: theme.palette.white.main,
    // boxShadow: '0px 0px 6px 0px rgba(1, 77, 108, 0.07)',
    top: '20%',
    transform: 'unset',

    fieldset: {
      border: `1px solid ${theme.palette.blue.main}`,
    },
  },

  '& .MuiFormHelperText-root': {
    marginTop: '12px !important',
  },
}));

export const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
  width: '100%',

  div: {
    height: '50px',
    borderRadius: '100px',
    backgroundColor: 'white',
    // boxShadow: '0px 0px 6px 0px rgba(1, 77, 108, 0.07)',

    fieldset: {
      border: `1px solid ${theme.palette.blue.main}`,
    },
  },

  // Force LTR direction and English standard layout for calendar
  '& *': {
    direction: 'ltr !important',
  },
  '& .MuiPickersPopper-root': {
    direction: 'ltr !important',
  },
  '& .MuiPaper-root': {
    direction: 'ltr !important',
  },
  '& .MuiPickersLayout-root': {
    direction: 'ltr !important',
  },
  '& .MuiPickersLayout-contentWrapper': {
    direction: 'ltr !important',
  },
  '& .MuiDateCalendar-root': {
    direction: 'ltr !important',
  },
  '& .MuiPickersCalendarHeader-root': {
    direction: 'ltr !important',
  },
  '& .MuiPickersCalendarHeader-labelContainer': {
    direction: 'ltr !important',
  },
  '& .MuiPickersArrowSwitcher-root': {
    direction: 'ltr !important',
  },
  '& .MuiPickersArrowSwitcher-spacer': {
    display: 'none',
  },
  '& .MuiDayCalendar-root': {
    direction: 'ltr !important',
  },
  '& .MuiDayCalendar-header': {
    direction: 'ltr !important',
    display: 'flex !important',
    flexDirection: 'row !important',
  },
  '& .MuiDayCalendar-weekContainer': {
    direction: 'ltr !important',
    display: 'flex !important',
    flexDirection: 'row !important',
  },
  '& .MuiDayCalendar-slideTransition': {
    direction: 'ltr !important',
  },
  '& .MuiPickersDay-root': {
    direction: 'ltr !important',
  },
}));

StyledDatePicker.defaultProps = {
  format: 'DD/MM/YYYY',
};

export const StyledTextArea = styled('textarea')(
  ({ theme, height = '130px' }) => ({
    width: '100%',
    height: height,
    borderRadius: '20px',
    backgroundColor: theme.palette.white.main,
    boxShadow: '0px 0px 6px 0px rgba(1, 77, 108, 0.07)',
    border: `1px solid ${theme.palette.blue.main}`,
    padding: '12px 16px',
    resize: 'none',
    fontSize: '16px',
    fontFamily: 'Heebo',
    outline: 'none',
  }),
);

export const StyledDateTimePicker = styled(DateTimePicker)(({ theme }) => ({
  width: '100%',

  div: {
    height: '50px',
    borderRadius: '100px',
    backgroundColor: 'white',

    fieldset: {
      border: `1px solid ${theme.palette.blue.main}`,
    },
  },
}));
